/**
 * グルーピング選択 入力用VOクラス
 *
 * @export KYMW0F00InputModel
 * @class KYMW0F00InputModel
 */
export class KYMW0F00InputModel {

  /** 取扱生協（いばらき）*/
  public EnableCoop142: string = <string>'0';
  /** 取扱生協（とちぎ）*/
  public EnableCoop163: string = <string>'0';
  /** 取扱生協（ぐんま）*/
  public EnableCoop185: string = <string>'0';
  /** 取扱生協（ちば）*/
  public EnableCoop240: string = <string>'0';
  /** 取扱生協（さいたま）*/
  public EnableCoop210: string = <string>'0';
  /** 取扱生協（とうきょう）*/
  public EnableCoop302: string = <string>'0';
  /** 取扱生協（ながの）*/
  public EnableCoop515: string = <string>'0';
  /** 取扱生協（にいがた）*/
  public EnableCoop451: string = <string>'0';
}
